import React from 'react';

import { messages } from '@qality/common-messages';
import { TestStepsView } from '@qality/common-model';

import './_test-case-box-step.scss';

type Props = {
  view: TestStepsView;
};
export default function TestStepsHeader({ view }: Props): JSX.Element {
  const { isDetailView } = view;

  const width = isDetailView ? '27%' : '50%';
  const attachmentBoxWidth = `${100 - 3 * parseFloat(width)}%`;

  return (
    <div className='test-steps-headers-container'>
      <div className='test-steps-headers'>
        <div className='test-steps-header column-header' style={{ width }}>
          <span>{messages['testCaseBoxStep.testStep.label']}</span>
        </div>
        {isDetailView && (
          <div className='test-steps-header column-header' style={{ width }}>
            <span>{messages['testCaseBoxStep.testData.label']}</span>
          </div>
        )}
        <div className='test-steps-header column-header' style={{ width }}>
          <span>{messages['testCaseBoxStep.expectedResult.label']}</span>
        </div>
        {isDetailView && (
          <div
            className='test-steps-header column-header'
            style={{ width: attachmentBoxWidth }}
          >
            <span>{messages['testCaseBoxStep.attachments.label']}</span>
          </div>
        )}
      </div>
    </div>
  );
}
